import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { createReservationStatuses } from 'modules/settings/api';

export const useMutationReservationStatuses = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(createReservationStatuses, {
    onSuccess: () => {
      successToast(t('Your settings are successfully updated'));
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_RESERVATION_STATUSES);
    },
    onError: () => errorToast(),
  });
};
